module.exports = __webpack_public_path__ + "static/img/GC.7140419.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/footer/img/GC.svg
// module id = KcxW
// module chunks = 42